import {checkIfSpecialBuilding} from '../../buildings/checkIfSpecialBuilding';
import {CONSTRUCTION_ACTION_TYPES} from '../../../constants/construction';
import {
  selectBuildingsDamage,
  selectHexes,
  selectPendingBuildings,
  selectSharedGameState,
  selectSpecialBuildings,
} from '../../../redux/reducers/sharedStateReducer/selectors';

export const checkIfRepairRecord = (building) => building.type === CONSTRUCTION_ACTION_TYPES.BUILDING_REPAIRMENT;

/**
 * Стор таким, каким он был бы, если бы действий строительства этого хода с
 * индексами removedIndexes не делали вовсе, и с выбранным жетоном
 * selectedToken (правила клика читают его из приватной ветки).
 *
 * Действия адресуются ИНДЕКСОМ в pendingBuildings, а не ссылкой на запись:
 * проверка конца хода возвращает копии записей, а редьюсер отмены пересоздает
 * запись фермы, получившей льготу Аграрианизма.
 *
 * Снимаются с конца: в ячейке с несколькими действиями хода остается то, что
 * было до самого раннего из снятых. Постройке возвращается previousToken
 * (дорога под ней) либо ячейка пустеет, спецстроение убирается, ремонт
 * возвращает снятый им урон — как редьюсеры UNDO_PENDING_BUILDING и
 * UNDO_REPAIR_BUILDING. Отличие одно: редьюсер стирает спецстроение ячейки при
 * отмене ЛЮБОГО ее действия, модель — только своего; набор, замкнутый по
 * ячейке (все более поздние действия ячейки сняты вместе с ранним), дает
 * одинаковый результат.
 * @param {Object} state
 * @param {Set<number>} removedIndexes
 * @param {{selectedToken?: string|null}} [options]
 */
export const rewindConstructionState = (state, removedIndexes, {selectedToken = null} = {}) => {
  const pendingBuildings = selectPendingBuildings(state);
  const hexes = {...selectHexes(state)};
  const specialBuildings = {...selectSpecialBuildings(state)};
  const buildingsDamage = {...selectBuildingsDamage(state)};

  for (let index = pendingBuildings.length - 1; index >= 0; index--) {
    if (!removedIndexes.has(index)) {
      continue;
    }
    const building = pendingBuildings[index];
    if (checkIfRepairRecord(building)) {
      buildingsDamage[building.hexKey] = (buildingsDamage[building.hexKey] || 0) + building.damage;
    } else if (checkIfSpecialBuilding(building.token)) {
      if (specialBuildings[building.hexKey] === building.token) {
        delete specialBuildings[building.hexKey];
      }
    } else if (building.previousToken) {
      hexes[building.hexKey] = building.previousToken;
    } else {
      delete hexes[building.hexKey];
    }
  }

  return {
    ...state,
    shared: {
      ...state.shared,
      hexes,
      gameState: {
        ...selectSharedGameState(state),
        pendingBuildings: pendingBuildings.filter((building, index) => !removedIndexes.has(index)),
        specialBuildings,
        buildingsDamage,
      },
    },
    private: {
      ...state.private,
      selectedEntities: {...state.private?.selectedEntities, selectedToken},
    },
  };
};
